import { IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PRIVACY_LINK, TERMS_LINK } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnboardingParamsTool } from '@/pages/Onboarding/utils/paramsTool';
import { canLogEvents } from '@/utils/canLogEvents';

import { SecurityStyles } from './Security.styles';

export const ScreenSecurity: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Security',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
    OnboardingParamsTool.setParam('step', 'name');
  };

  return (
    <SecurityStyles>
      <OnboardingNavigation />

      <IonContent scrollY={false}>
        <OnboardingTitle>
          Dialogue prioritizes and protects your personal information
        </OnboardingTitle>
        <Player
          className="animation"
          autoplay
          loop={false}
          keepLastFrame
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/security/data.json"
        />
        <UiTypography variant="headline-small" className="securityPolicy">
          What happens in Dialogue, <br />
          stays in Dialogue
        </UiTypography>

        <UiTypography className="disclaimer" variant="body-small">
          We never disclose your information. By tapping on Continue, you agree
          with our{' '}
          <a className="link" href={PRIVACY_LINK} target="_blank">
            Privacy Policy
          </a>{' '}
          and{' '}
          <a className="link" href={TERMS_LINK} target="_blank">
            Terms of Use
          </a>
        </UiTypography>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </SecurityStyles>
  );
};
